<template>

    <div class="poster">

        <!--        SORT_DURING_SCAN-->
        <div class="sort-during-scan" v-if="type === ENUM.HELP.FEATURES.SORT_DURING_SCAN">
            <img class="poster-image" src="/img/help/sort-scan/sort-scan-image.svg">
            <span class="here">{{ $t('help_here') }}</span>
            <span class="and-here">{{ $t('help_and_here') }}</span>
        </div>

        <!--        DELETED_MAILS-->
        <div class="deleted-mails" v-if="type === ENUM.HELP.FEATURES.DELETED_MAILS">
            <img class="poster-image" src="/img/help/deleted-mails/new-mail-image.svg">
            <span class="text">{{ $t('help_new_mails_received') }}</span>
            <span class="text text-2">{{ $t('help_new_mails_received') }}</span>
            <img src="/img/help/deleted-mails/arrow-1.svg" class="img-1">
            <img src="/img/help/deleted-mails/arrow-2.svg" class="img-2">
            <span class="here">{{ $t('help_here') }}</span>
            <span class="and-here">{{ $t('help_and_here') }}</span>
        </div>

        <!--        NEW_SENDERS-->
        <div class="new-senders" v-if="type === ENUM.HELP.FEATURES.NEW_SENDERS">
            <img class="poster-image" src="/img/help/new-sender/new-sender-image.svg">
            <span class="label"><div class="round"></div> {{ $t('help_new_mails_new') }}</span>
            <span class="label label-2"><div class="round"></div> {{ $t('help_new_mails_new') }}</span>
            <img src="/img/help/new-sender/arrow-1.svg" class="img-1">
            <img src="/img/help/new-sender/arrow-2.svg" class="img-2">
            <span class="here">{{ $t('help_here') }}</span>
            <span class="and-here">{{ $t('help_and_here') }}</span>
        </div>

        <!--        SORT_LATER-->
        <div class="sort-later" v-if="type === ENUM.HELP.FEATURES.SORT_LATER">
            <img class="poster-image" src="/img/help/sort-later/sort-later-image.svg">
            <span class="label"><img src="/img/newsletters-v2/later-blue.svg" class="later">{{ $t('cleaning_sender') }}</span>
            <span class="label label-2"><img src="/img/newsletters-v2/later-blue.svg" class="later"> {{ $t('cleaning_sender') }}</span>
            <img src="/img/help/sort-later/arrow-1.svg" class="img-1">
            <img src="/img/help/sort-later/arrow-2.svg" class="img-2">
            <span class="here">{{ $t('help_here') }}</span>
            <span class="and-here">{{ $t('help_and_here') }}</span>
        </div>

        <!--        REVERSE_ACTION-->
        <div class="reverse-action" v-if="type === ENUM.HELP.FEATURES.REVERSE_ACTION">
            <img class="poster-image" src="/img/help/history/history-image.svg">
            <span class="label"><img src="/img/newsletters-v2/clock-blue.svg" class="later">{{ $t('reverse_action') }}</span>
            <img src="/img/help/history/arrow-1.svg" class="img-1">
            <span class="here">{{ $t('help_here') }}</span>
        </div>

    </div>

</template>

<script>


export default {

    name: 'help-miniature',

    components: {},

    props: {
        type: {
            type: String,
            default: ''
        }
    },

    computed: {},

    data() {
        return {}
    },

    methods: {}


}

</script>

<style lang="scss" scoped>

.poster {
    width: 100%;
    display: flex;
    position: relative;
    font-size: 9px;
    font-style: normal;
    font-weight: 500;
    color: $white;
    @media screen and (min-width: $above-tablet-length) {
        font-size: 13px;
        font-weight: 700;
    }

    > div {
        width: 100%;
    }

    .poster-image {
        width: 100%;
    }

    .sort-during-scan {
        .here {
            position: absolute;
            top: 44%;
            left: 3%;
        }

        .and-here {
            position: absolute;
            top: 71%;
            left: 67%;
        }
    }

    .deleted-mails {
        .text {
            padding: 3px 5px;
            border-radius: 12px;
            background-color: $chardon;
            color: $sunset;
            position: absolute;
            top: 27%;
            left: 12%;
        }

        .text-2 {
            top: 50%;
            left: 63%;
        }

        .img-1 {
            position: absolute;
            top: 28%;
            left: 3%;
            width: 9%;
        }

        .img-2 {
            position: absolute;
            top: 60%;
            left: 59%;
            width: 9%;
        }
        .here {
            position: absolute;
            top: 43%;
            left: 3%
        }
        .and-here {
            position: absolute;
            top: 74%;
            left: 66%;
        }
    }

    .new-senders {
        .label {
            display: flex;
            flex-direction: row;
            align-items: center;
            padding: 3px 5px;
            border-radius: 28px;
            background-color: $white;
            position: absolute;
            top: 18%;
            left: 12%;
            color: $charcoal;

            .round {
                width: 7px;
                height: 7px;
                border-radius: 100%;
                background-color: $aquamarine;
                margin-right: 4px;
            }
        }

        .label-2 {
            top: 40%;
            left: 63%;
        }
        .img-1 {
            position: absolute;
            top: 20%;
            left: 3%;
            width: 9%;
        }

        .img-2 {
            position: absolute;
            top: 23%;
            left: 63%;
            width: 9%;
        }
        .here {
            position: absolute;
            top: 35%;
            left: 3%
        }
        .and-here {
            position: absolute;
            top: 21%;
            left: 71%;
        }
    }

    .sort-later {
        .label {
            display: flex;
            flex-direction: row;
            align-items: center;
            padding: 3px 5px;
            border-radius: 28px;
            background-color: $white;
            position: absolute;
            top: 18%;
            left: 12%;
            color: $charcoal;

            .later {
                width: 12px;
                margin-right: 4px;
            }
        }

        .label-2 {
            top: 40%;
            left: 63%;
        }
        .img-1 {
            position: absolute;
            top: 20%;
            left: 3%;
            width: 9%;
        }

        .img-2 {
            position: absolute;
            top: 23%;
            left: 63%;
            width: 9%;
        }
        .here {
            position: absolute;
            top: 35%;
            left: 3%;
            color: $charcoal;
        }
        .and-here {
            position: absolute;
            top: 21%;
            left: 71%;
            color: $charcoal;
        }

    }

    .reverse-action {
        .label {
            display: flex;
            flex-direction: row;
            align-items: center;
            padding: 3px 5px;
            border-radius: 28px;
            background-color: $white;
            position: absolute;
            top: 32%;
            right: 37%;
            color: $charcoal;

            .later {
                width: 12px;
                margin-right: 4px;
            }
        }
        .img-1 {
            position: absolute;
            top: 33%;
            right: 26%;
            width: 9%;
        }
        .here {
            position: absolute;
            top: 52%;
            right: 24%;
        }
    }
}


</style>
